export interface FeatureFlags {
  /**
   * プレビューのジェスチャーを行う際に2本指でのタッチを必要とするかどうか
   */
  requireTwoFingersForDragGesture: boolean

  /**
   * 全体を確認するダイアログを利用可能にするかどうか
   */
  overviewDialog: boolean

  /**
   * AIカスタマイズ機能を有効にするかどうか
   */
  enableAICustomization: boolean

  /**
   * ローカル・マイデザイン保存を有効にするかどうか
   */
  enableLocalMyDesignStorage: boolean

  /**
   * ログイン時のローカル→サーバ自動マージを有効にするかどうか
   */
  enableMyDesignMerge: boolean

  /**
   * マイデザイン一覧 UI（サーバ/ローカル統合）を有効にするかどうか
   */
  enableMyDesignList: boolean
}

export const defaultFeatureFlags: Readonly<FeatureFlags> = {
  requireTwoFingersForDragGesture: true,
  overviewDialog: true,
  enableAICustomization: true,
  enableLocalMyDesignStorage: true,
  enableMyDesignMerge: true,
  enableMyDesignList: false
}
